import { Box, Text } from "@mantine/core";
import React, { useEffect, useMemo, useState } from "react";
import McBimItemsCompTable from "../McBimItemsCompTable";
import { getDeviceCategoryForMcBimItem } from "../utils";
import SingleSpaceWithItemsViewer from "../SingleSpaceWithItemsViewer";
import { IMcBimItem, IRoom } from "@backend/src/schemas";
import { useAppSelector } from "../app/hooks";
import { selectHttpCurrentProjct } from "../projectSelectors";

const SingleStandardRoom: React.FC<{
  mcbimItemsInStandardSpace: IMcBimItem[];
  mcbimSpaceStandardRoom: IMcBimItem;
  room: IRoom;
}> = ({ mcbimItemsInStandardSpace, mcbimSpaceStandardRoom, room }) => {
  const [shouldRenderPixBimViewer, setShouldRenderPixBimViewer] = useState(false);
  const project = useAppSelector(selectHttpCurrentProjct);

  useEffect(() => {
    setShouldRenderPixBimViewer(false);
    const timer = setTimeout(() => {
      setShouldRenderPixBimViewer(true);
    }, 50);

    return () => clearTimeout(timer);
  }, [mcbimSpaceStandardRoom]);

  const mcBimItemsFormated = useMemo(() => {
    return mcbimItemsInStandardSpace
      ?.map((item) => {
        return {
          ...item,
          deviceCategory: getDeviceCategoryForMcBimItem({
            mcbimItem: item,
            compCodePath: project.compCodePath,
          }),
        };
      })
      .filter((item) => item.deviceCategory != null);
  }, [mcbimItemsInStandardSpace]);

  return (
    <Box h="100%" w="100%">
      <Box bg="blue.3">
        <Text c="black" size="lg">
          {mcbimSpaceStandardRoom?.name}, {room.rfpStatus}, {mcbimSpaceStandardRoom?.longName}
        </Text>
      </Box>
      <Box h="40%" w="100%" style={{ overflow: "hidden" }}>
        <McBimItemsCompTable
          mcbimItems={mcBimItemsFormated ?? []}
          compCodePath={project.compCodePath}
        />
      </Box>
      <Box h="60%" w="100%" style={{ overflow: "hidden" }}>
        {shouldRenderPixBimViewer && (
          <SingleSpaceWithItemsViewer
            mcbimSpace={mcbimSpaceStandardRoom}
            mcbimItemsInSpace={mcbimItemsInStandardSpace}
          />
        )}
      </Box>
    </Box>
  );
};

export default SingleStandardRoom;
